import React from 'react';
import { CheckCircle, AlertTriangle, Info } from 'lucide-react';

const FeedbackPanel = ({ feedback, isLoading }) => {
  if (isLoading) {
    return (
      <div className="p-4 bg-white rounded-lg shadow-sm">
        <h3 className="text-lg font-medium mb-4">Analyzing Your Response...</h3>
        <div className="animate-pulse space-y-4">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        </div>
      </div>
    );
  }

  if (!feedback) {
    return null;
  }

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm">
      <h3 className="text-lg font-medium mb-4">Performance Feedback</h3>
      
      <div className="mb-4">
        <div className="flex items-center mb-2">
          <div className="w-24 text-sm font-medium text-gray-600">Overall:</div>
          <div className="flex items-center">
            {[1, 2, 3, 4, 5].map((star) => (
              <svg 
                key={star}
                className={`w-5 h-5 ${star <= feedback.overallScore ? 'text-yellow-400' : 'text-gray-300'}`}
                fill="currentColor" 
                viewBox="0 0 20 20"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <h4 className="font-medium text-gray-900 flex items-center">
            <CheckCircle size={18} className="text-green-500 mr-2" />
            Strengths
          </h4>
          <ul className="mt-2 pl-6 list-disc text-sm text-gray-700 space-y-1">
            {feedback.strengths.map((strength, index) => (
              <li key={index}>{strength}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-medium text-gray-900 flex items-center">
            <AlertTriangle size={18} className="text-amber-500 mr-2" />
            Areas for Improvement
          </h4>
          <ul className="mt-2 pl-6 list-disc text-sm text-gray-700 space-y-1">
            {feedback.improvements.map((improvement, index) => (
              <li key={index}>{improvement}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-medium text-gray-900 flex items-center">
            <Info size={18} className="text-primary mr-2" />
            Suggested Approaches
          </h4>
          <ul className="mt-2 pl-6 list-disc text-sm text-gray-700 space-y-1">
            {feedback.suggestions.map((suggestion, index) => (
              <li key={index}>{suggestion}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPanel;